import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { NEW_EXPENSE_PATH, EXPENSE_PATH } from '../../../../config/paths';
import { postExpense } from '../../../../actions';
import ExpenseForm from './ExpenseForm';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import { tzNormalizeDate } from '../../../../utils/date';
import { TIMESTAMP_FORMAT } from '../../../../config/locale';

export class NewExpense extends Component {
  onSubmit = (formValues) => {
    const foodDetailList = formValues.itineraryAdditionalFoodTypeList
      ? formValues.itineraryAdditionalFoodTypeList.filter(
          (foodRequest) =>
            foodRequest &&
            foodRequest.foodId &&
            foodRequest.publicType &&
            foodRequest.quantity &&
            foodRequest.price,
        )
      : [];

    const hasFoodDetail = foodDetailList.length > 0;

    const amount = Number(formValues.amount || 0);

    const foodDetailTotal = foodDetailList.reduce((total, foodRequest) => {
      const price = Number(foodRequest.price || 0);

      return total + price;
    }, 0);

    if (hasFoodDetail && !formValues.itinerary) {
      toastr.error(
        'error',
        'Debe seleccionar un itinerario cuando digita detalle de alimentación.',
      );
      return;
    }

    if (
      hasFoodDetail &&
      Number(foodDetailTotal.toFixed(2)) !== Number(amount.toFixed(2))
    ) {
      toastr.error(
        'error',
        'El total del detalle de alimentación debe ser igual al monto digitado.',
      );
      return;
    }

    const postExpenseFormValues = {
      amount: formValues.amount,
      authorizerUserId: formValues.authorizerUserId.value,
      businessId: formValues.business ? formValues.business.value : null,
      description: formValues.description,
      documentCode: formValues.documentCode,
      documentSeries: formValues.documentSeries,
      createDate: formValues.expenseTypeId.createDate,
      expenseDescription: formValues.expenseTypeId.description,
      expenseCode: formValues.expenseTypeId.expenseCode,
      expenseTypeLabel: formValues.expenseTypeId.expenseTypeLabel,
      lastUpdate: formValues.expenseTypeId.lastUpdate,
      name: formValues.expenseTypeId.label,
      expenseTypeId: formValues.expenseTypeId.value,
      isSettled: formValues.isSettled || false,
      payeeCustomerId: formValues.payeeCustomerId.value,
      registeredBusId: formValues.registeredBusId
        ? formValues.registeredBusId.value
        : null,
      voucherTime: formValues.voucherTime
        ? tzNormalizeDate({
            date: formValues.voucherTime,
            format: TIMESTAMP_FORMAT,
          })
        : tzNormalizeDate({ format: TIMESTAMP_FORMAT }),
      voucherTypeId: formValues.voucherTypeId.value,
      costCenterId: formValues.costCenter ? formValues.costCenter.value : null,

      itineraryId: formValues.itinerary || null,

      comment: formValues.observation || null,

      itineraryAdditionalFoodTypeList: foodDetailList.map((foodRequest) => ({
        foodId: foodRequest.foodId.value || foodRequest.foodId,
        publicType: Array.isArray(foodRequest.publicType)
          ? foodRequest.publicType.map((pt) => pt.value || pt)
          : foodRequest.publicType.value || foodRequest.publicType,
        quantity: foodRequest.quantity,
        price: foodRequest.price,
      })),
    };

    let postBusinessFormValues = {
      businessTaxId: null,
      businessName: null,
      addressSummary: null,
    };

    if (formValues.businessTaxId) {
      postBusinessFormValues = {
        businessTaxId: formValues.businessTaxId,
        businessName: formValues.businessName,
        addressSummary: formValues.addressSummary,
      };
    }

    this.props.dispatchPostExpense(
      postExpenseFormValues,
      postBusinessFormValues,
    );
  };

  render() {
    return (
      <Content
        breadcrumbs={this.props.breadcrumbs}
        title="Nuevo Egreso"
        subtitle="Crear nuevo egreso"
        content={<ExpenseForm onSubmit={this.onSubmit} />}
      />
    );
  }
}

const mapStateToProps = ({ SalesUnit }) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    { text: 'Egresos', href: EXPENSE_PATH },
    { text: 'Nuevo', href: NEW_EXPENSE_PATH },
  ],
});

const mapDispatchToProps = { dispatchPostExpense: postExpense };

NewExpense.propTypes = {
  breadcrumbs: breadcrumbsPropTypes,
  dispatchPostExpense: PropTypes.func.isRequired,
};

NewExpense.defaultProps = {
  breadcrumbs: [],
};

export default connect(mapStateToProps, mapDispatchToProps)(NewExpense);
